"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var TabList_styled_exports = {};
__export(TabList_styled_exports, {
  StyledButton: () => StyledButton,
  StyledButtonContainerLeft: () => StyledButtonContainerLeft,
  StyledButtonContainerRight: () => StyledButtonContainerRight,
  StyledButtonWrapper: () => StyledButtonWrapper,
  StyledTabList: () => StyledTabList,
  StyledTabListContainer: () => StyledTabListContainer
});
module.exports = __toCommonJS(TabList_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_baseTheme = __toESM(require("../../../themes/baseTheme"));
var import_atoms = require("../../atoms");
var backgroundColors = {
  light: import_baseTheme.default.colors.white,
  subtle: import_baseTheme.default.colors.beige[60],
  dark: import_baseTheme.default.colors.black,
  transparent: import_baseTheme.default.colors.transparent.base
};
var StyledTabListContainer = import_styled_components.default.div.withConfig({
  displayName: "TabListstyled__StyledTabListContainer",
  componentId: "sc-me9ds6-0"
})(function(_ref) {
  var colorVariant = _ref.colorVariant;
  return (0, import_styled_components.css)(["display:inline-flex;width:100%;position:relative;box-sizing:border-box;background-color:", ";"], backgroundColors[colorVariant]);
});
var StyledTabList = import_styled_components.default.div.withConfig({
  displayName: "TabListstyled__StyledTabList",
  componentId: "sc-me9ds6-1"
})(function(_ref2) {
  var _ref2$scrollable = _ref2.scrollable, scrollable = _ref2$scrollable === void 0 ? false : _ref2$scrollable, itemsAlignment = _ref2.itemsAlignment, isResizeScroll = _ref2.isResizeScroll, withBorder = _ref2.withBorder;
  return (0, import_styled_components.css)(["box-sizing:border-box;align-items:flex-start;display:flex;flex-grow:1;flex-wrap:nowrap;margin:0;max-width:100%;min-block-size:fit-content;width:100%;", " ", " ", " ", " ", " ", " ", " &:-webkit-scrollbar{width:0;height:0;}"], itemsAlignment === "center" && !isResizeScroll && "justify-content: center;", withBorder && "border-bottom: 1px solid ".concat(import_baseTheme.default.colors.beige["180"], ";"), scrollable && "overflow: hidden;", scrollable && "overscroll-behavior-x: contain;", scrollable && "scroll-snap-type: x mandatory;", scrollable && "scrollbar-width: none;", scrollable && "flex-shrink: 0;");
});
var StyledButton = (0, import_styled_components.default)(import_atoms.Button).withConfig({
  displayName: "TabListstyled__StyledButton",
  componentId: "sc-me9ds6-2"
})(function(_ref3) {
  var isHidden = _ref3.isHidden, colorVariant = _ref3.colorVariant;
  return (0, import_styled_components.css)(["visibility:", ";background-color:", ";border-radius:0;height:24px;width:16px;box-shadow:none;"], isHidden ? "hidden" : "visible", backgroundColors[colorVariant]);
});
var StyledButtonContainerLeft = import_styled_components.default.div.withConfig({
  displayName: "TabListstyled__StyledButtonContainerLeft",
  componentId: "sc-me9ds6-3"
})(function(_ref4) {
  var isHidden = _ref4.isHidden, colorVariant = _ref4.colorVariant, arrowButtonBackgroundColor = _ref4.arrowButtonBackgroundColor;
  var gradient = {
    light: "linear-gradient(270deg, rgba(255, 255, 255, 0) 0.01%, ".concat(backgroundColors[colorVariant], " 100.01%);;"),
    subtle: "linear-gradient(270deg, rgba(242, 244, 237, 0) 0.01%, ".concat(backgroundColors[colorVariant], " 100.01%);"),
    transparent: "linear-gradient(270deg, rgba(242, 244, 237, 0) 0.01%, ".concat(arrowButtonBackgroundColor || backgroundColors.light, " 100.01%);")
  };
  return (0, import_styled_components.css)(["align-self:center;display:flex;justify-content:flex-start;visibility:", ";width:64px;left:0;position:absolute;height:100%;::after{content:'';width:24px;background:", ";}"], isHidden ? "hidden" : "visible", gradient[colorVariant]);
});
var StyledButtonContainerRight = import_styled_components.default.div.withConfig({
  displayName: "TabListstyled__StyledButtonContainerRight",
  componentId: "sc-me9ds6-4"
})(function(_ref5) {
  var isHidden = _ref5.isHidden, colorVariant = _ref5.colorVariant, arrowButtonBackgroundColor = _ref5.arrowButtonBackgroundColor;
  var gradient = {
    light: "linear-gradient(\n        270deg,\n        ".concat(backgroundColors[colorVariant], " 0.01%,\n        rgba(255, 255, 255, 0) 100.01%\n      );"),
    subtle: "linear-gradient(270deg, ".concat(backgroundColors[colorVariant], " 0.01%, rgba(242, 244, 237, 0) 100.01%);"),
    transparent: "linear-gradient(270deg, ".concat(arrowButtonBackgroundColor || backgroundColors.light, " 0.01%, rgba(255, 255, 255, 0) 100.01%);")
  };
  return (0, import_styled_components.css)(["align-self:center;display:flex;justify-content:end;visibility:", ";width:64px;right:0;position:absolute;height:100%;::before{content:'';width:24px;background:", ";}"], isHidden ? "hidden" : "visible", gradient[colorVariant]);
});
var StyledButtonWrapper = import_styled_components.default.div.withConfig({
  displayName: "TabListstyled__StyledButtonWrapper",
  componentId: "sc-me9ds6-5"
})(function(_ref6) {
  var colorVariant = _ref6.colorVariant, arrowButtonBackgroundColor = _ref6.arrowButtonBackgroundColor;
  return (0, import_styled_components.css)(["width:40px;background-color:", ";display:flex;height:100%;justify-content:center;align-items:center;"], arrowButtonBackgroundColor || backgroundColors[colorVariant]);
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledButton,
  StyledButtonContainerLeft,
  StyledButtonContainerRight,
  StyledButtonWrapper,
  StyledTabList,
  StyledTabListContainer
});
//# sourceMappingURL=TabList.styled.js.map